// extracted by mini-css-extract-plugin
export default {"taxonName":"Taxonomy_taxonName__34R1x"};